import React from "react"
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import CCORichText from "../../fundamentals/CCORichText/CCORichText";
import CCOLink from "../../fundamentals/CCOLink";
import {CmCollectionType} from "../../types";


export interface Props {
    cmCollection: CmCollectionType,
}


function C076Newsletterlinks(props: Props) {


    return (
        <>
            <Box sx={{
                alignSelf: 'start',
                width: '100%',
                height: '100%',
                p: {
                    xs: '24px',
                    lg: '48px 24px 24px 24px'
                },
                color: 'primary.contrastText',
                backgroundColor: 'primary.main',
                boxSizing: {xs: 'content-box', lg: 'inherit'},
                marginLeft: {xs: '-24px !important', lg: 'auto'}
            }}>
                <CCOHeadline metadataId={props.cmCollection.id}
                             headline={props.cmCollection.teaserTitle} type={"h4"} justify={"left"}
                             propertyName='properties.teaserTitle'/>
                <CCORichText metadataId={props.cmCollection.id}
                             textAsTree={props.cmCollection.teaserText?.textAsTree}
                             propertyName='properties.teaserText'/>
                <Grid container rowSpacing={2} columnSpacing={4}>
                    {
                        props.cmCollection.items?.map((item: any, index: number) => (
                            <Grid key={index} size={{xs: 12, md: 6, lg: 12}}>
                                <Button component={CCOLink}
                                        target={item}
                                        dataCypress={'newsletterButton' + index}
                                        sx={{
                                            marginTop: 3,
                                            width: '100%',
                                            color: 'text.primary',
                                            fontFamily: '"HelveticaNeueLTStd-Md", Helvetica, Arial, sans-serif',
                                            fontSize: '0.9375rem',
                                            backgroundColor: 'primary.contrastText',
                                            '&:hover': {
                                                backgroundColor: '#E0E0E0',
                                            }
                                        }}
                                > {item?.teaserTitle}</Button>
                            </Grid>
                        ))
                    }
                </Grid>
            </Box>
        </>
    );
}

export default C076Newsletterlinks